import { render, staticRenderFns } from "./PageToolbar.vue?vue&type=template&id=1ba7ed2c&scoped=true&"
import script from "./PageToolbar.vue?vue&type=script&lang=js&"
export * from "./PageToolbar.vue?vue&type=script&lang=js&"
import style0 from "./PageToolbar.vue?vue&type=style&index=0&id=1ba7ed2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba7ed2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VSpacer,VToolbar,VToolbarTitle})
